import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { useUrlFilters } from './_hooks/loadFiltersFromUrl'

const FilterWrapper = ({ children }) => {
  const initialFilter = useUrlFilters()
  // const lastViewData = getLocalStorageItem('service_orders_LAST_VIEW')

  return (
    <FilterHandler
      tempStorageNamespace="serviceOrders"
      initialState={{ ...initialFilter, fixedFilterFields: ['statusNames'] }}
    >
      {children}
    </FilterHandler>
  )
}

export default FilterWrapper
